import angular from 'angular';
import { FrequentOrdersListModule } from './frequent-orders-list/frequent-orders-list.module';
import { FrequentOrdersComponent } from './frequent-orders.component';
export var FrequentOrdersModule = angular
    .module('eeComUiApp.frequentOrders', [
    FrequentOrdersListModule
])
    .component('frequentOrders', FrequentOrdersComponent)
    .name;
//# sourceMappingURL=frequent-orders.module.js.map